import React from 'react'
import get from 'lodash/get'

import { Text } from '@fielded/shared-ui'

const LMDDeliveryDetailCoordinates = ({
  gpsObject
}) => {
  if (!gpsObject) return null

  return (
    <dd className='vs-u-margin-top-double'>
      <Text size='xsmall'>Most recent delivery location coordinates:</Text>
      <Text>Latitude: {get(gpsObject, 'lat')}</Text>
      <Text>Longitude: {get(gpsObject, 'lng') || get(gpsObject, 'long')}</Text>
    </dd>
  )
}

export default LMDDeliveryDetailCoordinates
